<style>
@import './assets/styles/w3.css';
@import './assets/styles/fontawesome.min.css';
@import './assets/styles/rc_main.css';
@import './assets/styles/rc_box.css';
@import './assets/styles/rc_text.css';
@import './assets/styles/rc_input.css';
@import './assets/styles/rc_font.css';
</style>
<template>
  <v-app v-if="!userRoles.isLocalDev || userRoles.isAdmin">
    <v-main >    
     <v-row>
       <v-col :cols="12">
         <app-header />   
       </v-col>
     </v-row>
     <v-row v-if="isAdmin">
       <v-col :cols="1">
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/company/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Companies</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/invoice/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Invoices</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/registration/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Registrations</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/vehicle/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Vehicles</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/user/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Users</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/inspection/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Inspections</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/hour/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Hours</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/checklist/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Checklists</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/report/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Reports</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/equipment/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Equipment</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/schedule/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Schedules</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/card/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Cards</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/map/list" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Map</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/whatsnew"  class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Whats New</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/dashboard" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Dashboard</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/stats" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Stats</router-link><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/blank" class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()" >Blank</router-link><br>
        </div>
       </v-col>

       <v-col :showBorder="false" :cols="10" :offset="0">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
       </v-col>
      </v-row>

      <v-row v-else>
       <v-col :showBorder="false" :cols="10" :offset="1">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
       </v-col>
     </v-row>

     <v-row>
       <v-col :cols="10" offset="1">
         <app-footer />
       </v-col>
     </v-row>
     
  </v-main>
  </v-app>
  <v-app v-else>
    <AppHeaderV3 v-if="showAuthenticatedLayout"
      :userInfo="userInfo"
      :company-name="companyInfo.name"
      :hasMultipleCompanies="companyInfo.hasMultiple"
      @navigate="onNavigate"
      @toggleSidebar="handleSidebarToggle" />
    <AppSidebarV3 v-if="showAuthenticatedLayout"
      :is-collapsed="isSidebarCollapsed"
      :is-mechanic="userRoles.isMechanic"
      :is-admin="userRoles.isAdmin"
      :is-local-dev="userRoles.isLocalDev"
      :features="companyFeatures"
      @navigate="onNavigate" />
    <v-main>
      <div>
        <router-view/>
      </div>
    </v-main>
    <AppFooterV3 v-if="showAuthenticatedLayout"
      :user="auth_user" 
      :client="auth_client" />
  </v-app> 
</template>
<script>
import { mapGetters } from 'vuex';
import AppHeader from '@/views/app/AppHeader.vue';
import AppFooter from '@/views/app/AppFooter.vue';

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      error: null,
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters([
      'auth_user',
      'auth_client',
      'roles_found',
      'user_role',
      'AuthStorage_Company',
      'domain',
    ]),
  },
  watch: {
    AuthStorage_Company() {
      this.isAdmin = this.domain.session().employee().find().roles().find().isAdministrator();
    },
  },
  methods: {},
  
};
</script>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import AppHeaderV3 from '@/v3/app/AppHeader.vue';
import AppSidebarV3 from '@/v3/app/AppSidebar.vue';
import AppFooterV3 from '@/v3/app/AppFooter.vue';



const router = useRouter();
const store = useStore();
const domain = computed(() => store.getters.domain);
const auth_user = computed(() => store.getters.auth_user);
const auth_client = computed(() => store.getters.auth_client);
const AuthStorage_Company = computed(() => store.getters.AuthStorage_Company);
const isSidebarCollapsed = ref(false);
const showAuthenticatedLayout = ref(false);



const handleSidebarToggle = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value;
};

const userRoles = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { isMechanic: false, isAdmin: false, isLocalDev: false };
  }
  const employee = domain.value.session().employee();
  const roles = employee ? employee.roles().find() : null;
  const isProduction = domain.value.client() ? domain.value.client().isProduction() : false;
  return {
    isMechanic: roles ? roles.isMechanic() : false,
    isAdmin: roles ? roles.isAdministrator() : false,
    isLocalDev: !isProduction,
  };
});

const companyFeatures = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return {};
  }
  const features = domain.value.session().company().features().find();
  if (!features) return {};

  return {
    inspections: features.allowsInspections(),
    timesheets: features.allowsTimesheets(),
    checklists: features.allowsCheckLists(),
    vehicles: features.allowsVehicles(),
    equipment: features.allowsEquipment(),
    tracking: features.allowsTrackLocation(),
    compliance: features.allowsCompliance(),
  };
});

const companyInfo = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { name: 'ReadyChek', idEncoded: null, hasMultiple: false };
  }
  const company = domain.value.session().company();
  const user = domain.value.session().user();
  const employees = user ? domain.value.employees().findByUserId(user.id()) : [];
  
  return {
    name: company ? company.name() : 'ReadyChek',
    idEncoded: company ? company.idEncoded() : null,
    hasMultiple: employees.length > 1,
  };
});

const userInfo = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { firstName: 'Guest', idEncoded: null };
  }
  const user = domain.value.session().user();
  return {
    firstName: user ? user.firstDisplay() : 'Guest',
    idEncoded: user ? user.idEncoded() : null,
  };
});

watch(AuthStorage_Company, (newCompany) => {
    let hasCompany = true;
    if (!newCompany) {
      hasCompany = false;
    }
    const isNewCompany = newCompany ? newCompany.isNew() : false;
    showAuthenticatedLayout.value = hasCompany && !isNewCompany;
  },
  { immediate: true }
);

const onNavigate = (path) => {
  if (!domain.value || !domain.value.session()) {
    console.error("Cannot navigate: domain or session not available.");
    return;
  }
  const companyId = domain.value.session().company().idEncoded();
  let newPath = `/portal/v3/operator/${companyId}/${path.value}`;
  if (path['version'] == null || path.version == '') {
    if (path['version'] == null) {
      newPath = `/portal/operator/${companyId}/${path}`;
    } else {
      newPath = `/portal/operator/${companyId}/${path.value}`;
    }
  }
  console.log('Navigating to:', newPath);
  router.push(newPath);
};
</script>